
<template>
  <!-- 联系我们模块 -->
  <div id="contact">
    <page-banner title="联系我们" content="向我们发送消息，我们的团队将很快与您联系。"></page-banner>
    <div class="breadcrumb-nav">
      <v-breadcrumb separator="/" separatorClass="fa fa-angle-right">
        <v-breadcrumb-item to="/">首页</v-breadcrumb-item>
        <v-breadcrumb-item to="/contact">联系我们</v-breadcrumb-item>
      </v-breadcrumb>
    </div>
    <div class="contact-info">
      <ul>
        <li v-for="item in contInfo" :key="item.info.title">
          <div class="info-icon">
            <i :class="item.info.iconname" style="color:rgb(0, 152, 239);font-size:56px;"></i>
          </div>
          <div class="contact-content">
            <div class="title">
              <h3>{{item.info.title}}</h3>
            </div>
            <div class>
              <p style="font-size:16px;">{{item.info.content}}</p>
            </div>
          </div>
        </li>
        <!-- <li>
          <div class="info-icon">
            <i class="fa fa-map-marker" style="color:rgb(0, 152, 239);font-size:56px;"></i>
          </div>
          <div class="contact-content">
            <div class="title">
              <h3>公司地址</h3>
            </div>
            <div class>
              <p>广州市海珠区江燕路江燕南一街8号</p>
            </div>
          </div>
        </li>-->
      </ul>
    </div>
   
  </div>
</template>

<style scoped>
#contact {
  width: 100%;
  height: 100%;
  min-height: 800px;
}
.contact-info {
  width: 1000px;
  height: 472px;
  padding-top: 25px;
  /* border: 1px solid black; */
  margin: 0px auto;
}
.contact-content {
  text-align: center;
}
.info-icon {
  text-align: center;
  margin: 15px 0 30px 0;
}
.title {
  margin: 14px 0 20px 0;
  font-size: 24px;
}
.contact-info ul {
  width: 1000px;
  height: 472px;
  float: left;
}
.contact-info li {
  width: 33%;
  height: 236px;
  float: left;
}
</style>
<script>
export default {
  name: "contact",
  data() {
    return {
      contInfo: [{
        info: {
          iconname: "fa fa-map-marker",
          title: "公司地址",
          content: "广东省广州市海珠区江南大道中路80号 创展自由港大厦 1309室"
        }
      }]
      // contInfo: [
      //   {
      //     iconname: "fa fa-map-marker",
      //     title: "公司地址",
      //     content: "广东省广州市海珠区江南大道中路80号 创展自由港大厦 1309室"
      //   },
      //   {
      //     iconname: "fa fa-phone",
      //     title: "联系电话",
      //     content: "4001898386"
      //   },
      //   {
      //     iconname: "fa fa-envelope",
      //     title: "电子邮箱",
      //     content: "248380151@qq.com"
      //   },
      //   {
      //     iconname: "fa fa-send-o ",
      //     title: "邮政编码",
      //     content: "510220"
      //   },
      //   {
      //     iconname: "fa fa-fax",
      //     title: "电话及传真号码",
      //     content: "020-31953926"
      //   },
      //   {
      //     iconname: "fa fa-home",
      //     title: "公司官网",
      //     content: "www.jj-dz.cn"
      //   }
      // ]
    };
  },
  methods: {},
  mounted() {
    var self = this;
    $.ajax({
      url: "/phonemanage.php",
      type: "get",
      data: null,
      headers: {
        "Content-Type": "application/json"
      },
      success: function(data, textStatus, jqXHR) {
        var data = JSON.parse(data);
        for(let i=0;i<data.length;i++){
          data[i].info = JSON.parse(data[i].info);
        }
        self.contInfo = data; 
      },
      error(jqXHR, status, errormsg) {}
    })
  }
};
</script>









// WEBPACK FOOTER //
// src/components/contact-content.vue